import React from 'react';
import { FormattedMessage } from 'react-intl';

export default {
    trackingLabel: 'Download on the App Store',
    icon: 'appStore',
    href: 'https://142876.measurementapi.com/serve?action=click&publisher_id=142876&site_id=90624&destination_id=171508&my_campaign=1stdibs-website&my_adgroup=sitewide-footer&my_ad=download-on-app-store-logo',
    dataTn: 'footer-download',
    formattedMessage: (
        <FormattedMessage
            id='dbl.Footer.app_link_download'
            defaultMessage='Download on the App Store'
        />
    )
};



// WEBPACK FOOTER //
// ./src/components/Footer/messages/appLink.jsx